export default __webpack_public_path__ + "static/skull-632e532ad875ca3bfce1b65e565bd126.png";